<template>
  <div class="loader">
    <div class="loader__icon"></div>
    <div class="loader__status" v-if="status">{{ status }}</div>
  </div>
</template>

<script>
export default {
  name: 'loading-spinner',
  props: {
    status: {
      required: false,
      type: String
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/_elements.loader.sass'
</style>
